import { css } from '@emotion/react';
import settings from '@settings';
import { h1, h2, h3, h4, h5, h6 } from '@styles';


export const layoutContainer = settings.mq({
	width: '100vw',
	height: '100vh',
	position: 'absolute',
	overflow: 'hidden',
	'main': {
		overflow: 'hidden',
		width: '100%',
		height: '100%',
		position: 'relative'
	},
	'h1': h1,
	'h2': h2,
	'h3': h3,
	'h4': h4,
	'h5': h5,
	'h6': h6,
	'p': {
		fontFamily: 'Coco Sharp',
		fontWeight: 400,
		fontSize: settings.fontSize.semismall,
		letterSpacing: '1px',
		lineHeight: 1.6,
		maxWidth: '360px',
		marginBlockEnd: settings.sizes.medium
	},
	'a': {
		fontFamily: 'Coco Sharp',
		fontWeight: 400,
		fontSize: settings.fontSize.semismall,
		letterSpacing: '1px',
		lineHeight: 1.6,
		textDecoration: 'underline',
		color: 'inherit',
		// maxWidth: '360px',
		marginBlockEnd: settings.sizes.medium
	},
	'ul': {
		marginBlockEnd: settings.sizes.medium
	},
	'li': {
		fontFamily: 'Coco Sharp',
		fontWeight: 400,
		fontSize: settings.fontSize.semismall,
		letterSpacing: '1px',
		lineHeight: 1.6,
		maxWidth: '360px',
		marginBlockEnd: settings.sizes.medium
	}
});

export const mobileLayoutContainer = settings.mq({
	position: 'relative',
	width: '100%',
	overflow: 'hidden',
	minHeight: '100vh',
	'h1': h1,
	'h2': h2,
	'h3': h3,
	'h4': h4,
	'h5': h5,
	'h6': h6,
	'p': {
		fontFamily: 'Coco Sharp',
		fontWeight: 400,
		fontSize: settings.fontSize.semismall,
		letterSpacing: '1px',
		lineHeight: 1.6,
		maxWidth: '360px',
		marginBlockEnd: settings.sizes.medium
	},
	'a': {
		fontFamily: 'Coco Sharp',
		fontWeight: 400,
		fontSize: settings.fontSize.semismall,
		letterSpacing: '1px',
		lineHeight: 1.6,
		textDecoration: 'underline',
		color: 'inherit',
		// maxWidth: '360px',
		marginBlockEnd: settings.sizes.medium
	},
	'ul': {
		marginBlockEnd: settings.sizes.medium
	},
	'li': {
		fontFamily: 'Coco Sharp',
		fontWeight: 400,
		fontSize: settings.fontSize.semismall,
		letterSpacing: '1px',
		lineHeight: 1.6,
		maxWidth: '360px',
		marginBlockEnd: settings.sizes.medium
	}
});

export const siteContentContainer = settings.mq({
	position: 'relative',
	overflowY: 'auto',
	overflowX: 'hidden',
	height: '100%',
	width: '100%',
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'center',
	alignItems: 'stretch',
});

export const siteInnerContent = settings.mq({
	width: '100%',
	height: '100%',
	marginLeft: 'auto',
	marginRight: 'auto',
	position: 'relative'
});

export const topline = css({
	fontFamily: 'Coco Sharp',
	fontWeight: 500,    
	fontSize: ['12px','18px', '24px'],
	color: settings.colors.grey,
	margin: 0,
	lineHeight: 1,
	letterSpacing: '2px'
})

export const numberDivider = (color: 'light' | 'dark') => settings.mq({
	fontFamily: 'Coco Sharp',
	fontWeight: 700,
	fontSize: ['36px','42px', '90vh'],
	color: color === 'light' ? settings.colors.light : settings.colors.dark,
	margin: 0,
	lineHeight: 1,
	letterSpacing: '2px',
	display: 'inline-block',
	textAlign: 'center',
	paddingBottom: settings.sizes.medium
})

export const smallContent = ({
	width = ['50vw', '50vw', '50vw'],
	padding= true,
	background = settings.colors.white
}: {
	width?: string[],
	padding?: boolean,
	background?: string
}) => css({
	backgroundColor: background,
    width: width ? width : "100vw",
	minHeight: '100vh',
    display: 'inline-block',
    position: 'relative',
})

export const largeContent = ({
    isFirst = false, 
    width = ['100vw', '100vw', '100vw'],
	height=['100vh', '100vh','100vh'],
    padding= true,
	background = settings.colors.white
}: {
    isFirst?: boolean,
	height?: string[],
    width?: string[],
    padding?: boolean,
	background?: string
}) => settings.mq({
	backgroundColor: background,
    width: width ? width : "100vw",
	height,
    display: 'inline-block',
    position: 'relative',
	overflow: 'hidden',
    paddingLeft: padding ?  isFirst ? ['18px', '18px', '180px'] : ['18px', '18px', '24px'] : 0,
    paddingRight: padding ? ['18px', '18px', '24px'] : 0,
    paddingBottom: padding ? ['42px', '42px', '120px'] : 0,
    paddingTop: padding ? ['42px', '42px', '120px'] : 0,
});

export const flexFull = settings.mq({
    width: '100%',
})

export const flexHalf = settings.mq({
    width: ['100%',  '50%'],
    padding: ['0', '0', settings.padding.small],
})
